import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";

export interface BreadcrumbItem {
  label: string;
  href?: string;
}

const LINK_DEFAULT = "text-accent-foreground cursor-pointer underline hover:text-accent-foreground hover:no-underline";
const LINK_CURRENT = "no-underline text-foreground pointer-events-none cursor-default";

export const Breadcrumbs: FC<{ items: BreadcrumbItem[] }> = ({ items }) => {
  const { t } = useTranslation("components");
  return (
    <nav aria-label={t("breadcrumbs.breadcrumb")} className="flex items-center text-sm leading-none">
      <ol className="flex flex-nowrap list-none p-0 m-0 gap-component-small">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <li key={`${item.href ?? ""}|${item.label}`} className="flex items-center">
              {item.href ? (
                <Link
                  to={item.href}
                  aria-current={isLast ? "page" : undefined}
                  className={isLast ? LINK_CURRENT : LINK_DEFAULT}
                >
                  {item.label}
                </Link>
              ) : (
                <span aria-current={isLast ? "page" : undefined} className={LINK_CURRENT}>
                  {item.label}
                </span>
              )}
              {!isLast && (
                <span aria-hidden="true" className="pl-[0.5em] text-muted-foreground">
                  /
                </span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};
